// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q3/2023zmxcq/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
// const getNewsList = (params: any) => {
//   return http.get(`/v1/news/topicList`, {
//     params,
//   });
// };
const getNewsList = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};


const getShowList = () => {
  return http.get(`${urlPrefix}show-list`);
};
const getRules = () => {
   return http.get(
    `${urlPrefix}rules`,
  );
};
export { getBaseInfo, getNewsList, getRules, getShowList };
